import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultDeviceInfo } from '../interfaces/DeviceIf'
import { useAuth } from './useAuth'

type ArgumentType = {
  loginId?: string
  rhq?: string
  token?: string
}
interface C201DeviceGetProps {
  execDeviceGet: ({ loginId, rhq, token }: ArgumentType) => Promise<ResultDeviceInfo>
  loading: loadStatus
}
// C201 デバイス取得API呼出
export const useC201DeviceGet = (): C201DeviceGetProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const execDeviceGet = async ({ loginId, rhq, token }: ArgumentType) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = token ? token : await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        return { success: false, message: errorMsg.SESSION_ERROR }
      }
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })
      const params: any = {}
      if (loginId) params.loginId = loginId
      if (rhq) params.rhq = rhq

      const response = await axios.get(`${baseUrl}${stage}${apiUrl.devicesPath}`, {
        headers: header,
        params: params,
        validateStatus: () => true,
      })

      if (response.status === apiStatus.SUCCESS) {
        // console.log(response.data);
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execDeviceGet, loading }
}
